import { UpdateFormComponent } from './update-form/update-form.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { FormsComponent } from './forms.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { CreateFormComponent } from './create-form/create-form.component'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const formsRoutes: Routes = [
  {
    path: 'admin/forms',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'FORMS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: FormsComponent,
        data: {
          permissions: {
            only: 'FORMS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        canActivate: [AuthGuard],
        component: CreateFormComponent,
        data: {
          permissions: {
            only: 'FORMS',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateFormComponent,
        data: {
          permissions: {
            only: 'FORMS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
